import React from 'react'

function USD({ className, size }) {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={size ?? 32}
      height={size ?? 32}
      fill='none'
      viewBox='0 0 32 32'
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z'
        fill='#00B26B'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.5 19.154C22.5 21.724 20.414 23.43 17.334 23.687V26H15.224V23.664C13.1407 23.4291 11.1613 22.6289 9.5 21.35L11.052 19.224C12.435 20.299 13.744 21 15.321 21.234V16.654C11.78 15.766 10.131 14.481 10.131 11.841C10.131 9.318 12.192 7.589 15.224 7.355V6H17.334V7.402C18.9831 7.58518 20.5554 8.19754 21.894 9.178L20.535 11.374C19.468 10.603 18.377 10.112 17.237 9.879V14.318C20.924 15.206 22.5 16.631 22.5 19.154ZM15.32 13.827V9.715C13.793 9.832 12.993 10.65 12.993 11.678C12.993 12.658 13.453 13.29 15.321 13.828L15.32 13.827ZM19.638 19.317C19.638 18.267 19.128 17.636 17.237 17.098V21.328C18.765 21.21 19.638 20.439 19.638 19.318V19.317Z'
        fill='white'
      />
    </svg>
  )
}

export default USD
